export default function Footer(){
    return (
        <div id="footer">
            <p id="copyright">&#169; Copyright Ellis Chang 2023.</p>
            
        </div>
    )
}